// import Stepper from '@components/Stepper';
// import Savings from '@common/components/Tags/Savings';
import CustomFieldHOC from '@common/components/CustomFieldHOC';
import { ProductAddToCartHOCRenderArgs } from '@common/components/ProductAddToCartHOC';
import ProductOptionsHOC from '@common/components/ProductOptionsHOC';
import useOnScreen from '@common/hooks/useOnScreen';
import { ReactComponent as ShipIcon } from '@common/icons/ShipIcon.svg';
import Product, { PRODUCT_TYPE } from '@common/models/Product';
import { STORE_TYPE } from '@common/models/StoreInfo';
import { addProductToCart } from '@common/store/cart/slice';
import { subtractProductFromCart } from '@common/store/cart/slice';
import { addToast } from '@common/store/toasts/slice';
import { smoothScroll } from '@common/utils';
import { isMobile } from '@common/utils';
// import { performCheckout } from '@common/utils/checkout';
import history from '@common/utils/history';
import SelectVariants from '@components/SelectVariants';
import Rupee from '@instamojo/rupee';
import Button from '@lib/Button';
import WishlistIcon from '@lib/WishlistIcon';
import classnames from 'classnames';
import React, { useRef, useState } from 'react';

import FormCheckboxRadioGroup from '../../../../lib-components/FormCheckboxRadioGroup';
import FormInput from '../../../../lib-components/FormInput';

interface ProductAddToCart {
  product: Product;
  cartProductQuantity: number;
  addToast: typeof addToast;
  addProductToCart: typeof addProductToCart;
  hocArgs: ProductAddToCartHOCRenderArgs;
  subtractProductFromCart: typeof subtractProductFromCart;
  storeType: string;
  quickView?: boolean;
  wishListFeature: boolean;

  // closeModal?: () => void;
}

const ProductAddToCart: React.FC<ProductAddToCart> = ({ product, quickView, hocArgs, wishListFeature, storeType }) => {
  const {
    finalProduct,
    editedPrice,
    setEditedPrice,
    editedPriceError,
    addToCart,
    variant,
    eventStartDate,
    eventStartTime,
    eventEndDate,
    eventEndTime,
    isBuyNowButtonDisabled,
    isAddToCartButtonDisabled,
    showAddToCartButtonAlt,
    discountCode,
    showTicketsLeft,
    finalPrice,
    savings,
    onWishListClickHandler,
    wishlist,
  } = hocArgs;

  const { selectedOptions, setSelectedOptions, quantity, setQuantity, selectedVariantCartQuantity } = variant;
  const { isProductInWishList } = wishlist;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [error, seterror] = useState(false);
  const cartCtaRef = useRef<HTMLDivElement>(null);
  const ctaRef = useRef<HTMLDivElement>(null);
  const showFixedBuyNow = !useOnScreen(cartCtaRef) && !quickView && !isBuyNowButtonDisabled;

  return (
    <div className="flex-1 flex flex-col">
      <div className="md:inline-flex mt-16 md:mt-20">
        {CostBar(finalPrice, savings)}
        {product.type !== PRODUCT_TYPE.DIGITAL
          ? QuantityOptionsBar(quantity, setQuantity, finalProduct, selectedVariantCartQuantity)
          : null}
      </div>
      {finalProduct.type === PRODUCT_TYPE.EVENT ? (
        <div className="w-full mt-22 md:w-auto mb-20" font-customisation="para-text">
          <div className="text-16 text-theme" color-customisation="page-body-text">
            DATE &amp; TIME
          </div>
          <div className="text-14 font-bold mt-6 uppercase">
            {eventStartDate === eventEndDate ? (
              <>
                <div>{eventStartDate},</div>
                <div>
                  {eventStartTime} - {eventEndTime}
                </div>
              </>
            ) : (
              <>
                <div>
                  {eventStartDate}&nbsp;&nbsp;{eventStartTime} - {eventEndDate}&nbsp;&nbsp;{eventEndTime}
                </div>
              </>
            )}
          </div>
          <div className="w-full md:w-auto mt-22">
            <div className="text-16 text-theme" color-customisation="page-body-text">
              VENUE
            </div>
            <div className="text-14 font-bold mt-6">{finalProduct.event?.venue}</div>
          </div>
          {showTicketsLeft ? (
            <div className="font-medium text-14 md:text-16 text-input-error mt-22">
              Only {finalProduct.stock} tickets left
            </div>
          ) : null}
        </div>
      ) : null}
      {finalProduct.payWhatYouWant ? (
        <FormInput
          name={'price'}
          className="my-22"
          label={`Pay what you want (Min ₹${finalPrice})`}
          type="text"
          value={editedPrice}
          onChange={(e) => setEditedPrice(e.target.value)}
          onBlur={() => console.log('NoOp')}
          error={editedPriceError}
        />
      ) : null}
      <ProductOptionsHOC
        product={product}
        addToCartHocArgs={hocArgs}
        renderFormField={({ form, formInputName, charges, productOption, multiple, typeOfInput }) => {
          const {
            values,
            errors,
            touched,
            submissions,
            // submitting,
            handleChange,
            handleBlur,
            asyncErrors,
            // setDynamicErrors,
          } = form;
          return (
            <FormInput
              name={formInputName}
              className="my-32 text-theme font-medium text-14 md:text-16 mr-4"
              label={`${productOption.name} ${charges}`}
              type={typeOfInput}
              multiple={multiple}
              value={values[formInputName] || ''}
              onChange={handleChange}
              onBlur={handleBlur}
              error={(submissions || touched[formInputName]) && (errors[formInputName] || asyncErrors[formInputName])}
            />
          );
        }}
        renderFormCheckboxRadioField={({ form, formInputName, optionType, optionValues, charges, productOption }) => {
          const {
            values,
            errors,
            touched,
            submissions,
            // submitting,
            handleChange,
            handleBlur,
            asyncErrors,
            // setDynamicErrors,
          } = form;
          return (
            <fieldset>
              <div
                className="my-12 text-theme font-medium text-14 md:text-16 mr-4"
                font-customisation="section-heading"
                color-customisation="page-heading"
              >
                {productOption.name} {charges}
              </div>
              <FormCheckboxRadioGroup
                className="mb-12 text-theme font-medium text-14 md:text-16 mr-4 -ml-10"
                name={formInputName}
                type={optionType as 'radio' | 'checkbox'}
                value={values[formInputName] || ''}
                onChange={handleChange}
                onBlur={handleBlur}
                options={optionValues.map((optionValue) => ({ id: optionValue.id, value: optionValue.text }))}
                error={(submissions || touched[formInputName]) && (errors[formInputName] || asyncErrors[formInputName])}
                optionsActiveClass="text-theme font-semibold"
              />
            </fieldset>
          );
        }}
      />

      <CustomFieldHOC
        product={product}
        addToCartHocArgs={hocArgs}
        renderFormField={({ customFieldForm, formInputName, charges, productOption, multiple, typeOfInput }) => {
          const { values, errors, touched, submissions, handleChange, handleBlur, asyncErrors } = customFieldForm;
          if (values[formInputName]) seterror(false);
          else if (!values[formInputName]) seterror(true);
          return (
            <FormInput
              name={formInputName}
              className="my-32 text-theme font-medium text-14 md:text-16 mr-4"
              label={`${productOption?.name} ${charges}`}
              type={typeOfInput === 'multifile' ? 'file' : typeOfInput}
              multiple={multiple}
              value={values[formInputName] || ''}
              onChange={handleChange}
              onBlur={handleBlur}
              maxLength={200}
              error={(submissions || touched[formInputName]) && (errors[formInputName] || asyncErrors[formInputName])}
            />
          );
        }}
        renderFormCheckboxRadioField={({
          customFieldForm,
          formInputName,
          optionType,
          optionValues,
          charges,
          productOption,
        }) => {
          const { values, errors, touched, submissions, handleChange, handleBlur, asyncErrors } = customFieldForm;
          if (values[formInputName]) seterror(false);
          else if (!values[formInputName]) seterror(true);
          return (
            <fieldset>
              <div
                className="my-12 text-theme font-medium text-14 md:text-16 mr-4"
                font-customisation="section-heading"
                color-customisation="page-heading"
              >
                {productOption.name} {charges}
              </div>
              <FormCheckboxRadioGroup
                className="mb-12 text-theme font-medium text-14 md:text-16 mr-4 -ml-10"
                name={formInputName}
                type={optionType as 'radio' | 'checkbox'}
                value={values[formInputName] || ''}
                onChange={handleChange}
                onBlur={handleBlur}
                options={optionValues.map((optionValue) => ({ id: optionValue.id, value: optionValue.text }))}
                error={(submissions || touched[formInputName]) && (errors[formInputName] || asyncErrors[formInputName])}
              />
            </fieldset>
          );
        }}
      />

      <div className="md:mb-10">
        {product.hasVariants ? (
          <div className="md:mb-40">
            <SelectVariants
              product={product}
              selectedOptions={selectedOptions}
              setSelectedOptions={setSelectedOptions}
              quantity={quantity}
              setQuantity={setQuantity}
            />
          </div>
        ) : null}

        {product.type !== PRODUCT_TYPE.DIGITAL ? (
          finalProduct.minQuantity > 1 ? (
            <div
              className="text-14 font-medium text-theme mt-12"
              font-customisation="para-text"
              color-customisation="page-body-text"
            >
              Min Order Qty: {finalProduct.minQuantity}
            </div>
          ) : null
        ) : null}
      </div>
      <div ref={ctaRef}>
        <div
          className={classnames('inline-flex w-full items-center mt-20 mb-10 md:mt-auto md:mb-14', {
            'flex-col md:flex-row': quickView,
            ' hidden': quickView && isMobile(),
          })}
        >
          {showAddToCartButtonAlt && (
            <>
              <button
                ref={cartCtaRef}
                className={classnames(
                  'w-123 px-16 py-14 md:p-0 md:w-214 md:h-48 h-40 focus:outline-none text-theme border-3 border-theme bg-white text-12 md:text-18 font-bold tracking-widest rounded-full pointer-events-auto max-w-220 flex justify-center items-center disabled:opacity-20',
                  { 'min-w-full md:min-w-0': quickView },
                )}
                // type="addToCartAlt"
                // designType={designType}
                disabled={isAddToCartButtonDisabled}
                onClick={() => {
                  addToCart({ isBuyNowFlow: false });
                  smoothScroll(0, 0);
                }}
                font-customisation="para-text"
                button-customisation="addToCart-button"
                id="add-to-cart-btn"
              >
                ADD TO CART
              </button>
              {BuyNowButton(product, isBuyNowButtonDisabled, quickView, addToCart, discountCode, storeType)}
            </>
          )}
          {!showAddToCartButtonAlt && (
            <>{BuyNowButton(product, isBuyNowButtonDisabled, quickView, addToCart, discountCode, storeType)}</>
          )}
          <WishlistIcon
            className="h-40 w-40 md:h-42 p-8 md:p-0 md:w-42 focus:outline-none text-theme border-3 border-theme bg-white text-14 md:text-18 font-bold tracking-widest rounded-full pointer-events-auto  max-w-300 flex justify-center items-center disabled:opacity-20 ml-12 md:ml-14"
            button-customisation="wishlist-button"
            type={isProductInWishList ? 'addWishList' : 'removeWishList'}
            wishListFeature={wishListFeature}
            onClick={() => {
              onWishListClickHandler();
            }}
          />
        </div>
        <div className="md:hidden">
          {product.type === PRODUCT_TYPE.PHYSICAL ? (
            <div className="mt-14 mb-24 flex text-13 text-shipIn-text">
              <ShipIcon></ShipIcon>
              <div className="ml-6" font-customisation="para-text" color-customisation="page-body-text">
                Standard shipping in {finalProduct.shipInDays} working days
              </div>
            </div>
          ) : null}
        </div>
      </div>

      {showFixedBuyNow ? (
        <div className="md:hidden fixed bottom-0 left-0 right-0 py-24 px-16 bg-opacity-90 z-99999 bg-white text-16 shadow-cartCta">
          <button
            onClick={() => ctaRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'center' })}
            className={classnames(
              'rounded-full bg-theme text-white h-40 md:h-48 w-150 md:w-180 text-14 md:text-18 tracking-widest justify-center items-center font-bold min-w-full md:min-w-0 md:ml-10',
            )}
            disabled={isBuyNowButtonDisabled}
            font-customisation="para-text"
            button-customisation="buyNow-button"
          >
            Buy Now
          </button>
        </div>
      ) : null}
    </div>
  );
};
export default ProductAddToCart;

const BuyNowButton = (product, isBuyNowButtonDisabled, quickView, addToCart, discountCode, storeType) => {
  return (
    <>
      {quickView ? (
        <Button
          className={classnames(
            'rounded-full bg-theme text-white h-40 md:h-48 w-150 md:w-180 text-14 md:text-18 tracking-widest justify-center items-center font-bold min-w-full md:min-w-0 md:ml-10',
          )}
          font-customisation="para-text"
          onClick={(e) => {
            e.preventDefault();
            history.push(product.storeLink);
          }}
          button-customisation="page-button"
        >
          VIEW DETAILS
        </Button>
      ) : (
        <button
          className="w-96 md:w-168 md:h-48 uppercase h-40 text-12 md:text-18 font-bold px-10 bg-theme text-white tracking-widest focus:outline-none rounded-full disabled:opacity-20 max-w-220 flex justify-center items-center ml-12 md:ml-14"
          font-customisation="para-text"
          button-customisation="buyNow-button"
          disabled={isBuyNowButtonDisabled}
          onClick={() => addToCart({ isBuyNowFlow: true, discountLinkPromoCode: discountCode })}
          id="buy-now-btn"
        >
          {storeType === STORE_TYPE.ENQUIRY ? 'Enquire Now' : !product.isExpired ? 'BUY NOW' : 'Expired'}
        </button>
      )}
    </>
  );
};

//QuantityOptionsBar
const QuantityOptionsBar = (quantity, setQuantity, product, cartQuantity) => {
  return (
    <div className="flex md:ml-40 md:leading-loose my-20 md:my-0">
      <div className="inline-flex items-center" font-customisation="para-text">
        <div className="flex text-theme font-medium text-14 md:text-16 mr-4 " color-customisation="page-body-text">
          Quantity:
        </div>
        {/* <div className="text-16 font-bold">{quantity}</div> */}
        <div className="flex text-14 md:text-16 font-semibold text-theme">
          <Button
            className="focus:outline-none h-30 w-42 bg-variant-bg font-semibold rounded-l-full rounded-r-none border-quantityButton-border border disabled:opacity-60 disabled:cursor-not-allowed"
            onClick={() => setQuantity(Math.max(quantity - 1, 1))}
            disabled={cartQuantity ? quantity === 1 : product.minQuantity === quantity}
          >
            <p id="quantity-decrement">-</p>
          </Button>
          <div
            className="flex focus:outline-none justify-center items-center h-30 w-42 border-quantityButton-border border-t border-b"
            color-customisation="page-body-text"
          >
            {quantity}
          </div>
          <Button
            className="focus:outline-none h-30 w-42 font-semibold bg-variant-bg rounded-r-full rounded-l-none border-quantityButton-border border disabled:opacity-60 disabled:cursor-not-allowed"
            onClick={() => setQuantity(quantity + 1)}
            disabled={
              product.stock >= product.maxQuantity ? product.maxQuantity === quantity : product.stock === quantity
            }
          >
            <p id="quantity-increment">+</p>
          </Button>
        </div>
      </div>
    </div>
  );
};

const CostBar = (finalPrice, savings) => {
  return (
    <div className="inline-flex justify-center items-center" font-customisation="para-text">
      <div
        className="flex text-pricing-current text-24 md:text-28 mr-14 font-semibold md:leading-snug"
        color-customisation="page-body-text"
        id="final-price"
      >
        <Rupee value={finalPrice} />
      </div>
      {savings ? (
        <div
          className="flex text-pricing-slashed line-through mt-4 font-medium text-16 md:leading-loose"
          id="original-price"
        >
          <Rupee value={savings.price} />
        </div>
      ) : (
        <div className="font-normal text-12">&nbsp;</div>
      )}
    </div>
  );
};
